import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserInfoService } from './user-info.service';
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(private userInfoService : UserInfoService,
            private router :Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.validateAccess();
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.validateAccess();
  }

  validateAccess() {
    let isAuthenticated :boolean = false;
    if(this.userInfoService.getToken() && this.userInfoService.isTokenValid()) {
      isAuthenticated= true;
    }
    if(!isAuthenticated) {
      this.router.navigate(["partner_login"])
    } 
    return true
    
  }
  loggedin(token:any) {
    const jwthelper = new JwtHelperService();
   // const currUser = JSON.parse(sessionStorage.getItem("currentUser"));
    let isTokenExpired: any
    if (token) {
      isTokenExpired = jwthelper.isTokenExpired(token);
    }
    //console.log(isTokenExpired)
    return isTokenExpired;
  }

  
}
